/*
 * @Description: 已完成文章修改
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-11 14:37:10
 * @LastEditTime: 2020-08-17 18:06:22
 */

import React from 'react'
class SetRedisInfo extends React.Component {
  render () {
    return (
      <div style={{padding: '100px 0', width: 1170, margin: 'auto', fontSize: 16}}>
        <button onClick={() => window.open('/digitalAssets/setRedisInfo', '_blank')}>已完成文章修改</button>
      </div>
    )
  }
}
export default SetRedisInfo;



// WEBPACK FOOTER //
// src/routes/setRedisInfo/SetRedisInfo.js